import { all, takeEvery, takeLatest } from 'redux-saga/effects';
import { fetchCategories, fetchGiftCards, fetchWithdrawalStatus } from '../actions';
import fetchWithdrawalStatusWorker from './worker.fetchWithdrawalStatus';
import fetchCategoriesWorker from './worker.fetchCategories';
import fetchGiftCardsWorker from './worker.fetchGiftCards';

function* karmaEarnSaga() {
  yield all([
    takeLatest(fetchWithdrawalStatus, fetchWithdrawalStatusWorker),
    takeLatest(fetchCategories, fetchCategoriesWorker),
    takeEvery(fetchGiftCards, fetchGiftCardsWorker),
  ]);
}

export default karmaEarnSaga;
